import React from "react";
import { caseSizes, caseSizesDefault } from "../../utils/constants";
import IncrDecrInput from "./IncrDecrInput.jsx";

class SetCaseMenuSizeComponent extends React.Component {
    constructor(props) {
        super(props);
        let Dyn = this.props.Dyn;
        this.state = {
            caseSize: this.caseSizeToMenuValue(Dyn.preferences.getCaseIconSize()),
            hasBubbles: Dyn.plotView?.plotShaper.hasElement(Dyn.EPlotControl.kControlsBubbles)
        };
    }

    caseSizeToMenuValue = (s) => {
        let smallestDiff = caseSizes.at(-1),
            value = caseSizesDefault;
        caseSizes.forEach( (n) => {
                let diff = Math.abs(n - s);
                if( diff < smallestDiff ) {
                    smallestDiff = diff;
                    value = n; // closest value
                }
            });
        return value;
    };

    setCaseIconSize = (m) => {
        let Dyn = this.props.Dyn;
        Dyn.preferences.setCaseIconSize(m);
    };

    updateCaseSize = () => {
        let Dyn = this.props.Dyn;
        this.setState({
            caseSize: this.caseSizeToMenuValue(Dyn.preferences.getCaseIconSize())
        });
    };

    updateHasBubbles = () => {
        let Dyn = this.props.Dyn;
        this.setState({
            hasBubbles: Dyn.plotView?.plotShaper.hasElement(Dyn.EPlotControl.kControlsBubbles)
        });
    }

    componentDidMount = () => {
        let { Dyn } = this.props;
        Dyn.addSubcribersToClean(
            Dyn.mediator.subscribe("pref:newCaseIconSize", () => {
                this.updateCaseSize();
            }));
        Dyn.addSubcribersToClean(
            Dyn.mediator.subscribe("plot:modelUpdated", () => {
                this.updateHasBubbles();
            }));
    };

    static sizeOptions = caseSizes.map( n => ({
        label: n.toString(),
        value: n }));

    render() {
        let Dyn = this.props.Dyn,
            label = Dyn.loc( this.state.hasBubbles ? "Bubble Size" : "Case Size");
        return (
            <IncrDecrInput
                label={label}
                onChange={(caseSize) =>
                    this.setState({ caseSize }, () =>
                        this.setCaseIconSize(caseSize)
                    )
                }
                getLoc={this.props.getLoc}
                value={this.state.caseSize}
                options={SetCaseMenuSizeComponent.sizeOptions}
                className={
                    "tde-mb-3" + this.props.isFromContextMenu
                        ? null
                        : this.props.reduceCaseCardWidth
                        ? " tde-fill"
                        : " tde-col-8"
                }
            ></IncrDecrInput>
        );
    }
}

export default SetCaseMenuSizeComponent;
